<template>
<div class="chapter">
<div class="inner_page">
<section class="div_autre" epub:type="preamble">
<h1 class="plm_hd"><a href="#/Text/DEUT_contents">Select bibliography</a></h1>
<h3 class="b_head" id="sigil_toc_id_1">Commentaries</h3>
<p class="biblio1">Cousins, Peter E., ‘Deuteronomy’ in <em class="italic">The International Bible Commentary</em> (Marshall Pickering, 1986).</p>
<p class="biblio1">Craigie, Peter C., <em class="italic">The Book of Deuteronomy</em> (<em class="italic">The New International Commentary on the Old Testament</em>, Eerdmans, 1976).</p>
<p class="biblio1">Harrison, R. K., and Manley, G. T., ‘Deuteronomy’ in <em class="italic">The New Bible Commentary Revised</em> (IVP, 1970).</p>
<p class="biblio1">Kline, Meredith G., ‘Deuteronomy’ in <em class="italic">The Wycliffe Bible Commentary</em> (Oliphants, 1963).</p>
<p class="biblio1">Mayes, A. D. H., <em class="italic">Deuteronomy</em> (<em class="italic">The New Century Bible</em>, Oliphants, 1979).</p>
<p class="biblio1">Payne, David F., <em class="italic">Deuteronomy</em> (<em class="italic">The Daily Study Bible</em> – Old Testament, St Andrew Press, 1985).</p>
<p class="biblio1">Phillips, Anthony, <em class="italic">Deuteronomy</em> (<em class="italic">The Cambridge Bible Commentary</em>, CUP, 1973).</p>
<p class="biblio1">Robinson, H. Wheeler, <em class="italic">Deuteronomy and Joshua</em> (<em class="italic">The Century Bible</em>, 1907).</p>
<p class="biblio1">Thompson, J. A., <em class="italic">Deuteronomy: An Introduction and Commentary</em> (<em class="italic">Tyndale Old Testament Commentaries</em>, IVP, 1974).</p>
<p class="biblio1">von Rad, Gerhard, <em class="italic">Deuteronomy</em> (<em class="italic">The Old Testament Library</em>, SCM, 1966).</p>
<p class="biblio1">Wright, G. E., ‘Deuteronomy’ in <em class="italic">The Interpreter’s Bible</em>, ﻿Vol. 2 (Abingdon Press, 1953).</p>
<h3 class="b_head" id="sigil_toc_id_2">Other works</h3>
<p class="biblio1">Blanch, Stuart, <em class="italic">The Ten Commandments</em> (Hodder and Stoughton, 1981).</p>
<p class="biblio1">Clements, R. E., <em class="italic">Deuteronomy: Old Testament Guides</em> (Sheffield Academic Press, 1989).</p>
<p class="biblio1">__, <em class="italic">God’s Chosen People: A Theological Interpretation of the Book of Deuteronomy</em> (SCM, 1968).</p>
<p class="biblio1">Davidman, Joy, <em class="italic">Smoke on the Mountain: An Interpretation of the Ten Commandments in Terms of Today</em> (Hodder and Stoughton, 1966).</p>
<p class="biblio1">Eddison, John, <em class="italic">God’s Frontiers</em> (Scripture Union, 1972).</p>
<p class="biblio1">Field, David, <em class="italic">God’s Good Life: The Ten Commandments at the End of the Twentieth Century</em> (IVP, 1992).</p>
<p class="biblio1">Kidner, Derek, <em class="italic">Hard Sayings: The Challenge of Old Testament Morals</em> (Tyndale Press, 1972).</p>
<p class="biblio1">Kline, Meredith G., <em class="italic">The Structure of Biblical Authority</em> (Eerdmans, 1972).</p>
<p class="biblio1">McConville, J. G., <em class="italic">Law and Theology in Deuteronomy</em> (Journal for the Study of the Old Testament Supplement Series 33, 1984).</p>
<p class="biblio1">Nicholson, E. W., <em class="italic">Deuteronomy and Tradition</em> (Blackwell, 1967).</p>
<p class="biblio1">Phillips, Anthony, <em class="italic">Ancient Israel’s Criminal Law: A New Approach to the Decalogue</em> (Darton, Longman and Todd, 1961).</p>
<p class="biblio1">Shields, Norman, <em class="italic">Pattern for Life</em> (Evangelical Press, 1983).</p>
<p class="biblio1">Weinfeld, M., <em class="italic">Deuteronomy and the Deuteronomic School</em> (Clarendon Press, 1972).</p>
<p class="biblio1">Wenham, John W., <em class="italic">The Enigma of Evil: Can We Believe in the Goodness of God?</em> (IVP, 1985).</p>
<p class="biblio1">Wright, Christopher J. H., <em class="italic">God’s People in God’s Land: Family, Land and Property in the Old Testament</em> (Paternoster/Eerdmans, 1990).</p>
<p class="biblio1">__, <em class="italic">Living as the People of God: The Relevance of Old Testament Ethics</em> (IVP, 1983).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DEUT_bibliog.vue?345e0372